import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GRID_CONFIG_DEFAULT } from 'src/pages/rotor-type-list/rotor-type-list.service';
import { GridConfig } from 'src/utils/interfaces/rotor-type.interfaces';
import { US_BASE_URL } from './tokens';

@Injectable({
  providedIn: 'root',
})
export class GridConfigApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(US_BASE_URL);

  private configGridBaseUrl: string;

  constructor() {
    const baseUrl = this.baseUrl;

    this.configGridBaseUrl = baseUrl + '/v1/currentUser/rotormanager/grid';
  }

  /**
   * Save grid config data
   */
  public save$(gridConfig: GridConfig) {
    return this.http.put(this.configGridBaseUrl, { data: gridConfig });
  }

  /**
   * Get available grid configuration
   */
  public get$(): Observable<GridConfig> {
    return this.http.get<{ data: GridConfig }>(this.configGridBaseUrl).pipe(
      map((result) => result.data),
      catchError(() => of(GRID_CONFIG_DEFAULT))
    );
  }
}
